
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id_utilisateur"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pk_lead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callback_at"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner_commercial_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clear_commercial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"piece_carte_grise"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"piece_permis"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"piece_releve"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updated_by"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCrmLeadState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id_utilisateur"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id_utilisateur"}}},{"kind":"Argument","name":{"kind":"Name","value":"pk_lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pk_lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"callback_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callback_at"}}},{"kind":"Argument","name":{"kind":"Name","value":"owner_commercial_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner_commercial_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"clear_commercial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clear_commercial"}}},{"kind":"Argument","name":{"kind":"Name","value":"piece_carte_grise"},"value":{"kind":"Variable","name":{"kind":"Name","value":"piece_carte_grise"}}},{"kind":"Argument","name":{"kind":"Name","value":"piece_permis"},"value":{"kind":"Variable","name":{"kind":"Name","value":"piece_permis"}}},{"kind":"Argument","name":{"kind":"Name","value":"piece_releve"},"value":{"kind":"Variable","name":{"kind":"Name","value":"piece_releve"}}},{"kind":"Argument","name":{"kind":"Name","value":"updated_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updated_by"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pk_lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callback_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calls_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner_commercial_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner_commercial_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"piece_carte_grise"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"piece_permis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"piece_releve"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":776}};
    doc.loc.source = {"body":"mutation (\n  $id_utilisateur: ID!\n  $pk_lead: ID!\n  $status: String\n  $callback_at: String\n  $owner_commercial_id: ID\n  $clear_commercial: Boolean\n  $piece_carte_grise: Boolean\n  $piece_permis: Boolean\n  $piece_releve: Boolean\n  $updated_by: String\n) {\n  updateCrmLeadState(\n    id_utilisateur: $id_utilisateur\n    pk_lead: $pk_lead\n    status: $status\n    callback_at: $callback_at\n    owner_commercial_id: $owner_commercial_id\n    clear_commercial: $clear_commercial\n    piece_carte_grise: $piece_carte_grise\n    piece_permis: $piece_permis\n    piece_releve: $piece_releve\n    updated_by: $updated_by\n  ) {\n    pk_lead\n    status\n    callback_at\n    calls_count\n    owner_commercial_id\n    owner_commercial_name\n    piece_carte_grise\n    piece_permis\n    piece_releve\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
